import {Component, forwardRef, Input} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";

@Component({
  selector: 'custom-radio-button',
  templateUrl: './radio-button.component.html',
  styleUrls: ['./radio-button.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RadioButtonComponent),
      multi: true
    }
  ]
})
export class RadioButtonComponent implements ControlValueAccessor {

  @Input() checked = false;

  @Input() blocked = false;

  @Input() value: any;

  @Input() name: any;

  private onChange = (_: any) => { /*void*/ };

  private onTouched = () => {/*void*/ };

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  writeValue(obj: any): void {
    //this.checked = this.value === obj  // Doesnt work with objects only with primitives;
  }

  onInput() {
    this.onTouched();
    this.onChange(this.value)
  }
}
